import { createContext } from 'react';
import '../core/enums/GameSpecificTypes.js';
import '../core/enums/MaxPayoutDataTypes.js';
import '../core/enums/Chat.js';
import '../core/enums/GameModes.js';
import '../core/enums/IconTypes.js';
import '../core/enums/BetStatus.js';
import '../core/enums/PopupTypes.js';
import '../core/enums/ApiVersion.js';
import '../core/enums/RoundStatus.js';
import '../core/enums/FreeBetsStatus.js';
import '../core/enums/SocketEvents.js';
import '../core/enums/TranslationKeys.js';
import '../core/enums/TimeoutMaxValue.js';
import '../core/enums/ApiServiceTypes.js';
import '../core/enums/EnvironmentTypes.js';
import '../core/enums/DefaultQueryValues.js';
import '../core/enums/FreeBetWinningType.js';
import '../core/enums/DefaultQueryParams.js';
import '../core/enums/BetHistoryFilterTypes.js';
import '../core/enums/GameThemeTypes.js';
import '../core/enums/RequestStatus.js';
import '../core/enums/FetchDefaultPaths.js';
import '../core/enums/ResponseCodes.js';
import '../../_tslib-7a01aab4.js';
import { N as applicationStore, o as betStore, r as popupStore, Q as userSettingsStore, D as userInfoStore, K as statisticsStore, w as lobbyStore, $ as gameConfigStore } from '../../validateBalanceOnBet-af4f4a9b.js';
import '../core/store/chatStore.js';
import '../core/store/wageringStore.js';
import { roundInfoStore } from '../core/store/roundInfoStore.js';
import { userCountStore } from '../core/store/userCountStore.js';
import { gameResultStore } from '../core/store/gameResultStore.js';
import { resultHashStore } from '../core/store/resultHashStore.js';
import '../core/store/userWinBetsStore.js';
import '../core/store/notificationStore.js';
import { selectedResultInfoStore } from '../core/store/selectedResultInfoStore.js';
import '../core/store/forCrashGame/inputValidationStore.js';
import '../core/store/forCrashGame/totalBetStore.js';
import '../core/store/forCrashGame/resultReportStore.js';
import '../core/store/forCrashGame/gameStore.js';
import '../core/services/liveConnection/types.js';
import 'axios';
import '../core/services/sound/types.js';
import '../core/services/sound/SoundService.js';
import '../core/services/sound/defaultSounds.js';
import '../core/services/api/types.js';
import '../core/services/ApiServices.js';
import '../../momentFormat-e9197995.js';
import '../core/polyfill.js';
import 'mobx';
import '../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../core/enums/BogLineGameConfig.js';
import '../core/helpers/parseQuery.js';
import '../core/enums/StatisticsSortingTypes.js';
import '../core/services/api/BaseApiService.js';
import '../core/helpers/deepCopy.js';
import '../../table-line/t_types/enums/BetResponseCode.js';
import '../../table-line/t_types/enums/BetErrorMessages.js';
import '../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../table-line/t_types/enums/FreeChipTypes.js';
import '../../table-line/t_types/enums/PopupTypes.js';
import '../core/helpers/formatDate.js';
import '../core/helpers/isMobile.js';
import '../core/enums/bogGameNames.js';
import '../core/helpers/updateHalfBets.js';
import 'howler';
import '../../_commonjsHelpers-17aad09c.js';

var defaultStoreDictionary = {
    applicationStore: applicationStore,
    betStore: betStore,
    popupStore: popupStore,
    userSettingsStore: userSettingsStore,
    userInfoStore: userInfoStore,
    resultHashStore: resultHashStore,
    statisticsStore: statisticsStore,
    lobbyStore: lobbyStore,
    gameResultStore: gameResultStore,
    roundInfoStore: roundInfoStore,
    gameConfigStore: gameConfigStore,
    userCountStore: userCountStore,
    selectedResultInfoStore: selectedResultInfoStore,
};
var StoreContext = createContext(defaultStoreDictionary);

export { StoreContext, defaultStoreDictionary };
